/* eslint-disable array-callback-return */
import React from 'react';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import { ChartPieComponent } from '../../../components/common/component/ChartPieComponent';
import Extend from '../../../components/common/Icon/extend.svg';
import { getMaxValue } from './chartsComponentHelper';
import { v4 as uuidv4 } from 'uuid';

export const sortDatesAscending = (dates: string[]) => {
  return dates.sort((a: any, b: any) => {
    const dateA = new Date(a.x);
    const dateB = new Date(b.x);
    return dateA.getTime() - dateB.getTime();
  });
};

export const ecpVolumeTable = (pLines: any) => {
  return (
    <table
      style={{
        width: '95%',
        margin: '15px',
        fontSize: '11px',
      }}
      className='ecpVolTable'
    >
      {pLines.map((line) => {
        return (
          <tr key={uuidv4()} style={line.css}>
            <td>{line.name}</td>
            <td>{line.nameBis}</td>
            <td>{line.value}</td>
            <td>{line.type !== 'PLUVIO' && line.percentage}</td>
          </tr>
        );
      })}
    </table>
  );
};

const errorMessage = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '90%',
        backgroundColor: 'white'
      }}
    >
      <br />
      <span style={{ color: 'red', fontSize: '14px' }}>Aucune données !</span>
    </div>
  );
}

export const displayEcpTableContainer = (pData: any[]) => {
  return (
    <>
      <div
        style={{ textAlign: 'center', fontSize: '16px', paddingTop: '15px' }}
      >
        <Word
          value='Composition du volume pompé'
          variant='span'
          textStyle='normalBold'
        />
      </div>
      {pData.length > 0 ? ecpVolumeTable(pData) : errorMessage()}
    </>
  );
};

export const getMax = (pData: any) => {
  let allMaxValues: number[] = [];
  pData.forEach((line) => {
    allMaxValues.push(getMaxValue(line, 'y', 'positive'));
  });
  return Math.max(...allMaxValues);
};

export const ecpLegendLine = (pColor: string, pTitle: string) => {
  return (
    <Container
      style={{
        display: 'flex',
        flexDirection: 'row',
        margin: '5px',
        width: 'max-content',
        alignItems: 'center',
      }}
    >
      <div
        style={{
          backgroundColor: pColor,
          borderRadius: '100%',
          width: '15px',
          height: '15px',
          marginRight: '10px',
        }}
      ></div>
      <Word className='ecp-legend-word' value={pTitle} textStyle='xxsRegular' />
    </Container>
  );
};

export const ecpGraphicsLegend = (pColors: string[], pTitles: string[]) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        marginTop: '20px',
      }}
    >
      {pColors.map((color, index) => {
        return ecpLegendLine(color, pTitles[index]);
      })}
    </div>
  );
};

export const h2sGraphicsLegend = (pColors: string[], pTitles: string[]) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        marginTop: '20px',
      }}
    >
      {pColors.map((color, index) => {
        return ecpLegendLine(color, pTitles[index]);
      })}
    </div>
  );
};

export const ecpChartPieContainer = (pData: any[], pProperties: any) => {
  return (
    <>
      <div
        style={{ textAlign: 'center', fontSize: '16px', paddingTop: '15px' }}
      >
        <Word value={pProperties.title} variant='span' textStyle='normalBold' />
      </div>
      <div
        style={pData.length > 0 ? {
          display: 'inline-flex',
          alignItems: 'center',
          position: 'relative',
          left: '6vw',
          width: '32vw'
        } : { height: '40vh' }}
      >
        {pData.length > 0 && ecpGraphicsLegend(pProperties.colorsLegend, pProperties.titlesLegend)}
        {pData.length > 0 ? ChartPieComponent(pData, pProperties) : errorMessage()}
      </div>
    </>
  );
};

// button for zoom in and zoom out on a graphic
export const zoomButton = (props: any) => {
  const handlerClick = () => {
    if (props.height === '50%') {
      props.handleZoomIn();
    } else {
      props.handleZoomOut();
    }
  };
  return (
    <div>
      <img
        id='ecp-graphic-extend'
        alt='Agrandir/réduire le graphique'
        title='Agrandir/réduire le graphique'
        src={Extend}
        style={{
          cursor: props.height === '50%' ? 'zoom-in' : 'zoom-out',
          margin: '5px',
        }}
        onClick={handlerClick}
        onKeyDown={handlerClick}
      ></img>
    </div>
  );
};

export const dateSplitter = (pDate: string) => {
  const dateSplitted = pDate.split('-');
  const year = Number(dateSplitted[0]);
  const day = Number(dateSplitted[2]);
  const month =
    Number(dateSplitted[1]) !== 0
      ? Number(dateSplitted[1]) - 1
      : Number(dateSplitted[1]);
  if (dateSplitted[2] === undefined) {
    return new Date(year, month);
  } else {
    return new Date(year, month, day);
  }
};

export const formatedPluvioDataForDailyAndMonthlyGraphics = (pData: any[]) => {
  const avoidNegativeValues = pData.filter((d) => {
    return (
      d.rr !== null && {
        d,
      }
    );
  });
  const data: any = avoidNegativeValues.map((d: any, index: number) => {
    return {
      id: index,
      y: Math.round(d.rr),
      x:
        d.year !== undefined
          ? new Date(Number(d.year), Number(d.month) - 1)
          : new Date(
              d.date.substr(0, 4),
              d.date.substr(4, 2) - 1,
              d.date.substr(6, 2),
            ),
      type: 'PLUIE',
    };
  });
  return sortDatesAscending(data);
};

export const calculatePartsForPieGraphic = (pData: any[]) => {
  let sum = 0;
  let dataUpdated: any[] = [];
  pData.forEach((d) => {
    if (d.type !== 'VTOT' && d.type !== 'PLUVIO') {
      sum += d.value > 0 ? d.value : 0;
    }
  });
  pData.forEach((d: any, index: number) => {
    let yValue =
      d.value <= 0
        ? 0
        : Math.round((d.value / sum) * 100 * Math.pow(10, 2)) / Math.pow(10, 2);
    dataUpdated.push({
      id: index,
      x: index,
      y: yValue,
      color: matriceForPieGraphicLegend.find((matrice) => d.type === matrice.type)?.css,
      title: matriceForPieGraphicLegend.find((matrice) => d.type === matrice.type)?.title,
      note: yValue.toString(),
      pourcentage: '%',
      type: d.type,
      value: Math.round(100 * d.value) / 100,
      order: matriceForPieGraphicLegend.find((matrice) => d.type === matrice.type)?.order !== undefined ? matriceForPieGraphicLegend.find((matrice) => d.type === matrice.type)?.order : 99,
    });
  });
  return dataUpdated.sort((a: any, b: any) => a.order - b.order);
};

export const getUniqueTypeValues = (pData: any[], pProperty: string) => {
  let uniqueNames = pData
    .map((item) =>
      pProperty === 'x'
        ? new Date(item[pProperty]).toString()
        : item[pProperty],
    )
    .filter((value, index, self) => self.indexOf(value) === index);
  
  if(pProperty === 'type') {
    const uniqueNamesWithOrder = uniqueNames.map((typeName) => {
      return matriceForPieGraphicLegend.find((matrice) => matrice.type === typeName);
    });
    const uniqueNamesOrdered = uniqueNamesWithOrder.sort((a: any, b: any) => a.order - b.order);
    uniqueNames = uniqueNamesOrdered.map((typeName: any) => typeName.type);
  }
  return uniqueNames;
};

export const dataGroupedByTypeOrDate = (
  pTypeNames: string[],
  pData: any[],
) => {
  let dataDateFormated = pData.map((d) => { return { ...d, dateFormated: new Date(d.x).toLocaleDateString('fr') }});
  let typeNameFormated = pTypeNames.map((d) => { return new Date(d).toLocaleDateString('fr') });
  let data = typeNameFormated.map((typeName: string) => {
    return dataDateFormated.filter(
      (d) =>
        d.dateFormated ===
         typeName
    );
  });
  return data;
};

export const sum = (pData: any[], pProperty: string) => {
  return pData.reduce(
    (accumulator, currentValue) => accumulator + currentValue[pProperty],
    0,
  );
};

export const sumByType = (pData: any[], pTypeValues: string[]) => {
  const avoidUndefinedValues = pTypeValues.map((type) => {
    return pData.map((groupByDate) => {
      let dataByType: any = groupByDate.filter((d) => type === d.type);
      if (dataByType.length !== 0) {
        return { ...dataByType[0], y: sum(dataByType, 'y') };
      }
    });
  });
  return avoidUndefinedValues.map((array) => {
    return array.filter((d) => d !== undefined);
  });
};

export const prepareTableData = (pData: any[]) => {
  let calculVTOT = 0;
  pData.forEach((d) => {
    if (d.type === 'VEUS') {
      calculVTOT += d.value;
    }
    if (d.type === 'VECPC') {
      calculVTOT += d.value;
    }
    if (d.type === 'VECPI') {
      calculVTOT += d.value;
    }
    return calculVTOT;
  });

  let transformedData = tableConfig.map((line) => {
    let data: any = pData.filter((d) => {
      return line.type.includes(d.type);
    });
    let value, percentage;
    if (data.length === 2) {
      value = parseFloat(sum(data, 'value').toFixed(2)).toLocaleString() + ' m³';
      percentage = parseFloat(sum(data, 'y').toFixed(2)).toLocaleString() + ' %';
    } else if (data.length === 1) {
      value =
        data[0].type === 'VTOT'
          ? parseFloat(calculVTOT.toFixed(2)).toLocaleString() + ' m³'
          : parseFloat(data[0].value.toFixed(2)).toLocaleString() + `${data[0].type === 'PLUVIO' ? ' mm' : ' m³'}`;
      percentage = data[0].type === 'VTOT' ? '' : parseFloat(data[0].y.toFixed(2)).toLocaleString() + ' %';
    } else {
      value = 'NR';
      percentage = '';
    }
    return {
      ...line,
      value: value,
      percentage: percentage,
    };
  });

  const pluviometerIndex = transformedData.findIndex((line) => line.type === 'PLUVIO' && line.percentage === '');
  if (pluviometerIndex !== -1) {
    transformedData.splice(pluviometerIndex + 1, 0, {
      id: 7,
      name: '',
      nameBis: 'Pas de pluviomètre attaché, donc pas de calculs ECP',
      value: '',
      percentage: '',
      css: { color: 'red', fontWeight: 'bold' },
      type: 'PLUVIO_MESSAGE',
    });
  }

  return transformedData;
};

export const matriceForPieGraphicLegend = [
  {
    type: 'VEUS',
    css: '#D4C2F3',
    title: 'Eaux sanitaires',
    order: 0
  },
  {
    type: 'VECPI',
    css: '#F4C172',
    title: "Eaux parasites d'infiltration",
    order: 1
  },
  {
    type: 'VECPC',
    css: '#24386F',
    title: 'Eaux parasites de captage (PR)',
    order: 2
  },
  {
    type: 'VDEV',
    css: '#1584B7',
    title: 'Eaux parasites de captage (DO)',
    order: 4
  },
];

export const formatedDataForDailyAndMonthlyGraphics = (pData: any[]) => {
  let avoidNegativeValues = pData.filter((d) => {
    return (
      d.value !== null &&
      d.value >= 0 &&
      d.type !== 'VTOT' && {
        d,
      }
    );
  });
  const data: any = avoidNegativeValues.map((d, index: number) => {
    return {
      id: index,
      y: Math.round(d.value),
      x: dateSplitter(d.day !== undefined ? d.day : d.month),
      type: d.type,
      css: matriceForPieGraphicLegend.find((matrice) => d.type === matrice.type)
        ?.css,
      order: matriceForPieGraphicLegend.find((matrice) => d.type === matrice.type)
      ?.order
    };
  });
  return sortDatesAscending(data);
};

export const getColorsLegendForDailyAndMonthlyCharts = (pData: any[]) => {
  let cssCodes: any[] = [];
  pData.forEach((dataByType) => {
    dataByType.forEach((data, index) => {
      if (index === 0) {
        cssCodes.push(
          matriceForPieGraphicLegend.find((c) => c.type === data.type)?.css,
        );
      }
    });
  });
  return cssCodes;
};

export const initDates = async () => {
  const now = new Date();
  return {
    start: { year: now.getFullYear() - 1, month: 1, day: 1 },
    end: { year: now.getFullYear() - 1, month: 12, day: 31 },
  };
};

export const dateFormatedForRequest = (pDate: any, pMode: string) => {
  const separator = pMode === 'pluvio' ? '' : '-';
  const start =
    pDate.start.year.toString() +
    separator +
    (pDate.start.month < 10
      ? '0' + pDate.start.month.toString()
      : pDate.start.month.toString()) +
    separator +
    (pDate.start.day < 10
      ? '0' + pDate.start.day.toString()
      : pDate.start.day.toString());
  const end =
    pDate.end.year.toString() +
    separator +
    (pDate.end.month < 10
      ? '0' + pDate.end.month.toString()
      : pDate.end.month.toString()) +
    separator +
    (pDate.end.day < 10
      ? '0' + pDate.end.day.toString()
      : pDate.end.day.toString());
  return { startDate: start, endDate: end };
};

export const tableConfig = [
  {
    id: 0,
    name: 'Volume sanitaire',
    nameBis: '',
    value: '',
    percentage: '',
    type: 'VEUS',
  },
  {
    id: 1,
    name: 'Volume déversé',
    nameBis: 'Captage DO',
    value: '',
    percentage: '',
    type: 'VDEV',
  },
  {
    id: 2,
    name: "Volume d'eaux parasites",
    nameBis: 'Captage PR',
    value: '',
    percentage: '',
    css: {
      backgroundColor: '#ECF1F8',
    },
    type: 'VECPC',
  },
  {
    id: 3,
    name: '',
    nameBis: 'Infiltration',
    value: '',
    percentage: '',
    css: { backgroundColor: '#ECF1F8' },
    type: 'VECPI',
  },
  {
    id: 4,
    name: '',
    nameBis: 'Total eaux parasites',
    value: '',
    percentage: '',
    css: {
      backgroundColor: '#ECF1F8',
      fontWeight: 'bolder',
    },
    type: 'VECPI_VECPC',
  },
  {
    id: 5,
    name: 'Volume total cumulé',
    nameBis: '',
    value: '',
    percentage: '100%',
    css: { fontWeight: 'bolder' },
    type: 'VTOT',
  },
  {
    id: 6,
    name: 'Cumul pluviométrique',
    nameBis: '',
    value: '',
    percentage: '',
    css: { backgroundColor: '#CCE8F6' },
    type: 'PLUVIO',
  },
];

export const createDateForMonthlyGraphic = (pData: any[], pTypeValues: any[]) => {
  const dataDateFormated = pData.map((d) => { return { ...d, dateFormated: new Date(d.x).toLocaleDateString('fr').slice(3) }});
  const dateDateFormatedValues = getUniqueTypeValues(dataDateFormated, 'dateFormated');
  const sumByTypeForMonthlyData = pTypeValues.map((type) => {
    return dateDateFormatedValues.map((date: any) => {
      const dataByType: any = dataDateFormated.filter((d) => date === d.dateFormated && type === d.type);
      if (dataByType.length !== 0) {
        return {
          ...dataByType[0],
          y: sum(dataByType, "y"),
          x: new Date(
            dataByType[0].dateFormated.split("/")[1],
            Number(dataByType[0].dateFormated.split("/")[0]) - 1
          ),
        };
      }
    });
  });
  const sumByTypeForMonthlyDataAvoindUndefined = sumByTypeForMonthlyData.map((array) => {
    return array.filter((d) => d !== undefined);
  });
  return sumByTypeForMonthlyDataAvoindUndefined;
};